module.exports = __webpack_public_path__ + "img/cubes.a3c267.svg";